import axios from 'axios';
import store from '../store';
import router from '../router';

import { AUTH_LOGOUT } from '../store/actions/auth';

const api = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}api`,
});

api.interceptors.response.use(
  (request) => request,
  (error) => {
    const { response, config } = error;

    if (!config.url.includes('auth') && response.status == 401) {
      store.dispatch(AUTH_LOGOUT);
      router.push('/');
    }

    return Promise.reject(error);
  }
);

export default api;
